/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'truck-fast-outline-int': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 32',
    data: '<path pid="0" d="M.75 7.5h9.75l.75 1.5H1.5L.75 7.5m1 3h9.75l.75 1.5H2.5l-.75-1.5m16.25 8c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5m1.5-9H17V12h4.46L19.5 9.5M8 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5M20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3h-4c0 1.66-1.35 3-3 3-1.66 0-3-1.34-3-3H3v-3.5h2V15h.76c.55-.61 1.35-1 2.24-1 .89 0 1.69.39 2.24 1H15V6H3c0-1.11.89-2 2-2h12v4h3z"/><text x="50%" y="32" text-anchor="middle">INT</text>'
  }
})
